const WebSocketMessageNameConstants = {
  LISTING_SYNDICATION_STATUS: 'listingSyndicationStatus',
  EMAIL_VERIFIED: 'emailVerified',
  USER_FEED_TO_MANUAL_STATUS: 'userFeedToManualStatuses',
  BILLING_PORTAL_BATCH_PAYMENT_COMPLETE: 'billingPortalBatchPaymentComplete',
};

export default WebSocketMessageNameConstants;
